styles += """
  #back-to-top {
    position: fixed;
    right: 30px;
    bottom: 30px;
    height: 46px;
    width: 46px;
    z-index: 10;
  }

"""
BackToTopButton = ->

  BUTTON 
    className: 'like_link'
    "data-tooltip": "To top"
    id: 'back-to-top'
    onClick: -> scrollTo 0, 0
    "aria-label": "Go back to the top of the page"

    SPAN 
      style: 
        visibility: 'hidden'
        fontSize: 0
      'Back to top'

    SVG 
      width: "100%"
      height: "100%"
      viewBox: "0 0 700 700" 

      PATH
        d: "m630 280c0-154.56-125.44-280-280-280s-280 125.44-280 280 125.44 280 280 280 280-125.44 280-280zm-539.28 0c0-142.8 116.48-259.28 259.28-259.28s259.28 116.48 259.28 259.28-116.48 259.28-259.28 259.28-259.28-116.48-259.28-259.28z"
        stroke: 'black'

      PATH
        d: "m360.64 416.64v-238l71.121 71.121c3.9219 3.9219 10.641 3.9219 14.559 0 3.9219-3.9219 3.9219-10.641 0-14.559l-96.32-96.324-96.32 96.32c-2.2383 2.2383-2.8008 4.4805-2.8008 7.2812s1.1211 5.0391 2.8008 7.2812c3.9219 3.9219 10.641 3.9219 14.559 0l71.121-71.121v238c0 5.6016 4.4805 10.641 10.641 10.641s10.641-4.4805 10.641-10.641z"
        stroke: 'black'



styles += """
  .footer_buttons {
    position: relative;
    margin: auto;
    text-align: center;
    top: -60px;
    display: flex; 
    justify-content: center;
  }

  [data-url="/"] .footer_buttons {
    display: none;
  }

  .footer_nav {
    margin-bottom: 35px;
    display: flex;
    flex-wrap: wrap;
    max-width: 866px; 
    margin: auto;
    gap: 28px 28px;    
  }

  @media (min-width: 700px) {
    .hide_on_desktop: {
      display: none;
    }
  }

  @media (max-width: 700px) {
    .footer_nav {
      padding-top: 36px;
      flex-direction: column;
    }

    .hide_on_mobile {
      display: none;
    }
  }

"""

window.ProductFooter = ReactiveComponent
  displayName: 'ProductFooter'

  render: -> 
    loc = fetch 'location'

    section_div = (section) -> 
      DIV null,
        H3 
          style: 
            fontSize: 18
            fontWeight: 500
            color: '#000'
            marginBottom: 10
          section.label 

        UL 
          style: 
            listStyle: 'none'

          for link in section.links when link?
            LI 
              key: link.label
              style:
                marginBottom: 10
                

              A 
                href: link.link
                style: 
                  color: primary_color()
                  textDecoration: 'underline'
                  fontSize: 16
                  fontWeight: 500

                link.label

    draw_top_button = true || loc.url not in ['/create_forum', '/']

    FOOTER
      ref: 'footer'
      id: 'footer'
      style: 
        paddingTop: if loc.url == '/' || loc.url.indexOf('/examples') > -1 || loc.url == '/create_forum' || loc.url == '/contact' then 0 else 140
        backgroundColor: if loc.url != '/' && loc.url.indexOf('/examples') < 0 then 'white'
        bottom: 0
        left: 0
        zIndex: 2
        width: '100%'
        position: 'relative'
        marginTop: if loc.url == '/contact' then -47


      if draw_top_button
        BackToTopButton()

      DIV 
        style:
          backgroundColor: "#F4F4F4"
          borderTop: if loc.url != '/contact' then "1px solid ##{737373}"
          padding: "#{if loc.url == '/create_forum' || loc.url == '/contact' then 64 else 20}px 0 15px 0"
          position: 'relative'
          zIndex: 3

        DIV 
          style: 
            width: "var(--SAAS_PAGE_WIDTH)"
            margin: 'auto'

          # buttons 

          if loc.url != '/contact'
            DIV 
              className: 'footer_buttons hide_on_mobile'

              
              if loc.url != '/create_forum'
                A 
                  href: '/create_forum'
                  # className: 'condensed'                
                  style: _.extend {}, big_button(), 
                    backgroundColor: if loc.url == '/' || loc.url.indexOf('/examples') > -1 then '#717171' else primary_color()
                    maxWidth: 410
                    flexGrow: 1
                  'Create a Free Forum'

              if loc.url.indexOf('/examples') > -1
                A 
                  href: '/contact?form=request_demo'
                  # className: 'condensed'
                  target: '_blank'
                  style: _.extend {}, big_button(), 
                    backgroundColor: '#717171'
                    marginLeft: 32
                    maxWidth: 410
                    flexGrow: 1
                  'Request a demo'

              else if loc.url != '/create_forum'
                A 
                  className: 'hide_on_mobile'
                  href: demo_url()
                  target: '_blank'
                  # className: 'condensed'
                  style: _.extend {}, big_button(), 
                    backgroundColor: '#717171'
                    marginLeft: 32
                    maxWidth: 410
                    flexGrow: 1
                  'Try a Demo'



          # nav sections
          if loc.url != '/' 
            DIV 
              className: 'footer_nav'

              for section in nav() 
                DIV 
                  key: section.label
                  style: 
                    textAlign: 'center'
                    flexGrow: 1

                  section_div section

          if loc.url != '/' 

            DIV 
              style: 
                textAlign: 'center'
                marginTop: 48

              "Don't hesitate to "

              A 
                href: '/contact'

                'contact us'
              '!'

              " Or learn more "
              A 
                href: '/contact#about_us'

                'about us'
              '.'


          # more info

          DIV 
            style: 
              fontSize: 16
              textAlign: 'center'
              marginTop: 48

            DIV 
              style:
                marginBottom: 18

              A 
                href: 'https://github.com/Considerit/ConsiderIt'
                className: 'monospaced'
                style: 
                  textDecoration: 'underline'
                  # fontWeight: 600
                  fontSize: 20

                target: '_blank'

                "Consider.it is Open Source"
                IMG 
                  alt: "github logo"
                  src: asset('product_page/github_logo.png')
                  style: 
                    height: 18
                    paddingLeft: 6
                    verticalAlign: 'middle'

            DIV 
              style: 
                color: '#303030'
                display: 'flex'
                alignItems: 'center'
                justifyContent: 'center'
                flexWrap: 'wrap'
                # padding: "0 50px"
                gap: "10px 20px"
                margin: 'auto'

              SPAN null, 
                DIV 
                  style: 
                    display: 'inline-block'
                  '© Consider.it. All rights reserved.' 
                A
                  href: '/docs/legal/privacy_policy'
                  style: 
                    textDecoration: 'underline'
                    fontSize: 16
                    paddingLeft: 6
                  'Privacy'
                ' and '
                A
                  href: '/docs/legal/terms_of_service'
                  style: 
                    textDecoration: 'underline'
                    fontSize: 16
                  'Terms'
                '.'

              A 
                href: 'mailto:hello@consider.it'
                style: 
                  textDecoration: 'underline'
                  display: 'inline-block'
                'hello@consider.it'


              
  sizeFooter: -> 
    f = fetch 'footer' 
    height = @refs.footer.offsetHeight
    if height != f.height
      f.height = height 
      save f 

  componentDidMount: -> @sizeFooter()
  componentDidUpdate: -> @sizeFooter()



nav = -> [

  {
    label: 'How does it work?'
    links: [

      if WINDOW_WIDTH() >= 900
        {
          label: 'Interactive Demo'
          link: '/tour'
        }

      {
        label: 'Feature Tour'
        link: '/tour#features'
      }

      {
        label: 'Try a Demo Forum'
        link: demo_url()
      }

    ]
  }, 

  {
    label: 'I want a forum for…'
    links: [
      {
        label: 'Public Involvement'
        link: '/examples/public_engagement'
      }, 
      {
        label: 'Strategic Planning'
        link: '/examples/strategic_planning'
      }, 
      {
        label: 'Decentralized Organizing'
        link: '/examples/decentralized_decisions'
      }, 
      # {
      #   label: 'Something Else'
      #   link: ''
      # }
    ]
  },   


  {
    label: 'What will it cost?'
    links: [
      {
        label: 'Plans'
        link: '/pricing'
      }, 
      {
        label: 'Consulting Services'
        link: '/pricing#consulting'
      }
    ]
  },
  # {
  #   label: 'Hello, friend!'
  #   links: [
  #     {
  #       label: 'Contact Us'
  #       link: '/contact'
  #     }, 
  #     {
  #       label: 'Partnering'
  #       link: '/contact?form=request_demo'
  #     }, 
  #     {
  #       label: 'Request a demo'
  #       link: '/contact?form=request_demo'
  #     }, 

  #     # {
  #     #   label: 'Our History'
  #     #   link: '/contact#history'
  #     # }, 
  #     # {
  #     #   label: 'Our Team'
  #     #   link: '/contact#team'
  #     # }
  #   ]
  # }
]





/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/footer.coffee
 **/